export default __webpack_public_path__ + "static/Entenda0124-03a757394b03bfe6d3c0657132b0ddd9.jpg";